import { render, staticRenderFns } from "./ResidentialView.vue?vue&type=template&id=8cf688a6"
import script from "./ResidentialView.vue?vue&type=script&lang=js"
export * from "./ResidentialView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports